import { LinearProgress } from "@mui/material"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import JSONPretty from "../../JSONpretty"

export type ComponentTableRelationInspectDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  loading: boolean
  data: unknown
}

export function ComponentTableRelationInspectDialog({
  open,
  onOpenChange,
  title,
  loading,
  data,
}: ComponentTableRelationInspectDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{title || "Related item"}</DialogTitle>
          <DialogDescription>Related row details loaded on demand.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3">
          {loading ? (
            <LinearProgress />
          ) : data ? (
            <JSONPretty json={data} />
          ) : (
            <div className="text-sm text-gray-500 dark:text-gray-400">No data</div>
          )}
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
